var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Negative_notification",
    "data-name": "Negative notification",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9022",
    "data-name": "Rectangle 9022",
    width: 16,
    height: 16,
    transform: "translate(4370 -3386)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3240",
    "data-name": "Ellipse 3240",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fd8770"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exclamation_mark",
    "data-name": "Exclamation mark",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6750",
    "data-name": "Mask Group 6750",
    transform: "translate(-4370 3386)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38816",
    "data-name": "Group 38816",
    transform: "translate(0 57.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30097",
    "data-name": "Group 30097",
    transform: "translate(4376.714 -3443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30646",
    "data-name": "Path 30646",
    d: "M816.022,758.191a1.289,1.289,0,0,1,1.1-1.4,1.331,1.331,0,0,1,1.467,1.4,1.257,1.257,0,0,1-1.182,1.285A1.323,1.323,0,0,1,816.022,758.191Zm.523-3.916-.269-9.215a.492.492,0,0,1,.492-.507h1.079a.492.492,0,0,1,.492.507l-.269,9.215a.763.763,0,0,1-.763.741h0A.763.763,0,0,1,816.544,754.274Z",
    transform: "translate(-816.021 -744.553)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.f1684fe6dd3f9952cf8e2a0bbe9c03ef.svg";
export { ForwardRef as ReactComponent };